import React from "react";

import {
  FiPlus,
  FiRefreshCcw,
  FiSearch,
} from "react-icons/fi";

import {
  DEFAULT_DEPARTMENTS,
  EMPLOYEE_STATUSES,
  EMPLOYMENT_TYPES,
} from "../utils/employee.constants";

import {
  formatEmployeeLabel,
  getObjectId,
  getUniqueOptions,
} from "../utils/employee.utils";

import "./EmployeeManagement.css";


const EmployeeFilters = ({
  filters,

  setFilters,

  dropdownData = {},

  loading = false,

  dropdownLoading = false,

  onSearch,

  onReset,

  onAddEmployee,
}) => {

  const departments =
    getUniqueOptions(
      dropdownData.departments,
      DEFAULT_DEPARTMENTS
    );


  const statuses =
    getUniqueOptions(
      dropdownData.statuses,
      EMPLOYEE_STATUSES
    )
      .filter(
        (
          status
        ) =>
          EMPLOYEE_STATUSES
            .includes(
              String(
                status
              )
                .trim()
                .toUpperCase()
            )
      );


  const employmentTypes =
    getUniqueOptions(
      dropdownData.employmentTypes,
      EMPLOYMENT_TYPES
    );


  const roles =
    Array.isArray(
      dropdownData.roles
    )
      ?
      dropdownData.roles
      :
      [];


  const disabled =
    loading ||
    dropdownLoading;


  const handleChange = (
    event
  ) => {

    const {
      name,
      value,
    } =
      event.target;


    setFilters(
      (
        previous
      ) => ({
        ...previous,

        [name]:
          value,
      })
    );

  };


  const handleKeyDown = (
    event
  ) => {

    if (
      event.key ===
      "Enter"
    ) {

      event.preventDefault();

      onSearch?.();

    }

  };


  return (

    <section className="employee-filter-card">

      <div className="employee-filter-heading">

        <div>

          <span>
            FILTER EMPLOYEES
          </span>

          <h2>
            Search and filter records
          </h2>

        </div>


        <button
          type="button"
          className="employee-filter-add-button"
          onClick={
            onAddEmployee
          }
          disabled={
            disabled
          }
        >

          <FiPlus />

          Add Employee

        </button>

      </div>


      <div className="employee-filter-grid">

        <div className="employee-filter-field employee-filter-search-field">

          <label>
            Search Employee
          </label>


          <div className="employee-filter-input-wrapper">

            <FiSearch />

            <input
              type="text"
              name="search"
              value={
                filters?.search ||
                ""
              }
              onChange={
                handleChange
              }
              onKeyDown={
                handleKeyDown
              }
              placeholder="Name, employee code, mobile..."
              disabled={
                disabled
              }
            />

          </div>

        </div>


        <div className="employee-filter-field">

          <label>
            Department
          </label>

          <select
            name="department"
            value={
              filters?.department ||
              ""
            }
            onChange={
              handleChange
            }
            disabled={
              disabled
            }
          >

            <option value="">
              All Departments
            </option>

            {
              departments.map(
                (
                  department
                ) => (

                  <option
                    key={department}
                    value={department}
                  >
                    {department}
                  </option>

                )
              )
            }

          </select>

        </div>


        <div className="employee-filter-field">

          <label>
            Role
          </label>

          <select
            name="roleId"
            value={
              filters?.roleId ||
              ""
            }
            onChange={
              handleChange
            }
            disabled={
              disabled
            }
          >

            <option value="">
              All Roles
            </option>

            {
              roles.map(
                (
                  role
                ) => (

                  <option
                    key={
                      getObjectId(
                        role
                      )
                    }
                    value={
                      getObjectId(
                        role
                      )
                    }
                  >

                    {
                      role?.name ||
                      formatEmployeeLabel(
                        role?.code
                      )
                    }

                  </option>

                )
              )
            }

          </select>

        </div>


        <div className="employee-filter-field">

          <label>
            Employment Type
          </label>

          <select
            name="employmentType"
            value={
              filters?.employmentType ||
              ""
            }
            onChange={
              handleChange
            }
            disabled={
              disabled
            }
          >

            <option value="">
              All Types
            </option>

            {
              employmentTypes.map(
                (
                  type
                ) => (

                  <option
                    key={type}
                    value={type}
                  >
                    {
                      formatEmployeeLabel(
                        type
                      )
                    }
                  </option>

                )
              )
            }

          </select>

        </div>


        <div className="employee-filter-field">

          <label>
            Status
          </label>

          <select
            name="status"
            value={
              filters?.status ||
              ""
            }
            onChange={
              handleChange
            }
            disabled={
              disabled
            }
          >

            <option value="">
              All Statuses
            </option>

            {
              statuses.map(
                (
                  status
                ) => (

                  <option
                    key={status}
                    value={status}
                  >
                    {
                      formatEmployeeLabel(
                        status
                      )
                    }
                  </option>

                )
              )
            }

          </select>

        </div>


        <div className="employee-filter-actions">

          <button
            type="button"
            className="employee-filter-search-button"
            onClick={
              onSearch
            }
            disabled={
              disabled
            }
          >

            <FiSearch />

            Search

          </button>


          <button
            type="button"
            className="employee-filter-reset-button"
            onClick={
              onReset
            }
            disabled={
              disabled
            }
          >

            <FiRefreshCcw />

            Reset

          </button>

        </div>

      </div>

    </section>

  );

};


export default EmployeeFilters;